import { useParams } from "react-router-dom";
import { AgreementProvider } from "../context";
import AgreementContent from "./AgreementContent";
import { AgreementAlert } from "./shared";

const AgreementDirectory = () => {
  const { agreementId } = useParams();

  return agreementId ? (
    <AgreementProvider agreementId={agreementId}>
      <AgreementContent />
    </AgreementProvider>
  ) : (
    <AgreementAlert
      title="agreement.noData"
      message="agreement.noAgreementId"
    />
  );
};

export default AgreementDirectory;
